var initSizeChart = function initSizeChart() {
  var sizechartBtns = document.querySelectorAll('.sizechart-js-btn');
  var sizechartClose = document.querySelectorAll('.sizechart-js-close');
  var sizechartContainer = document.querySelector('.size-chart-container');
  if (!sizechartBtns) {
    return;
  }
  sizechartBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById(btn.dataset.id).classList.add('opened');
    }, {
      passive: false
    });
  });
  sizechartClose.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      btn.closest('.sizechart-js').classList.remove('opened');
    });
  });
  sizechartContainer.addEventListener('click', function (e) {
    e.stopPropagation();
    sizechartContainer.classList.remove('opened');
  });
};
export { initSizeChart };